<div class="relative flex cursor-pointer flex-col items-center gap-3 rounded-md border border-dashed border-stone-700 bg-transparent p-3">
  <form id="formImageEdit">
    <input on:change type="file" name="userImage" class="absolute inset-0 cursor-pointer opacity-0" accept="image/*" />
  </form>
  <span class="text-xl text-extraBlue-500">
    <i class="fa-solid fa-image" />
  </span>
  <div class="flex flex-col items-center justify-center">
    <p class="text-sm text-gray-500">
      Upload Image <span>or drag and drop</span>
    </p>
    <span class="select-none pt-2 text-center text-xs font-normal text-gray-500">Maximum Size 2MB</span>
    <span class="pt-2 text-xs text-gray-500">Choose jpeg, jpg, png files</span>
  </div>
</div>
